import Vue from "vue";
import Router from "vue-router";
import { ROUTER_DATA } from "@/constants/ROUTER_DATA";
Vue.use(Router);
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...ROUTER_DATA,
    {
      path: "*",
      redirect: "/index"
    }
  ],
  scrollBehavior() {
    // router的滚动到顶部的行为部分路由切换会失效，所以这里使用手动方式处理
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    // 始终滚动到顶部
    return { top: 0, left: 0 };
  }
});
